export default function getCursorForNode(datum) {

  return datum.hasChild || datum.id === 'default'
    ? 'pointer'
    : 'move';
}
